import noise2D from '../../../_shaders/noise2-d'

export default `${noise2D}
  uniform sampler2D uOutlineTexture;


  uniform vec3 uBaseColor;
  uniform vec3 uOutlineColor;
  varying vec2 vUv;
  varying vec3 vNormal2;

  void main() {
    vec2 uv = vec2(vUv.x, 1.0 - vUv.y);

    float n = snoise(uv * 1.5 + vec2(0.0, -0.5)) * 0.5 + 0.5;
    float outline = texture2D(uOutlineTexture, uv).r;
    vec3 color = mix(uBaseColor, uOutlineColor, n * n);
    color = mix(color, uOutlineColor, outline);

    vec3 normal = normalize(vNormal2 * vec3(0.4, 1.0, 1.0));

    float light = max(0.0, dot(normal, normalize(vec3(0.0, 0.5, 1.0))));
    light = pow(light, 50.0);

    float light2 = max(0.0, dot(normalize((vNormal2) * vec3(1.0, 2.0, 2.0)), normalize(vec3(0.0, -0.5, 2.0))));
    light2 = pow(light2, 50.0);
    light = mix(light, light2, 0.3);

    // color = vec3(light2);
    color = mix(color, color * 6.0, light);

    color += light2 * color * 5.0;


    color = pow(color, vec3(1.0 / 2.2));
    gl_FragColor = vec4(color, 1.0);
  }
`
